import { render } from 'preact';
import './style.css';
import { App } from './app.js';

const root = document.getElementById('root');
if (!root) throw new Error('[stillsun-admin] missing #root in index.html');
render(<App />, root);
